import { useContext, useState } from "react";
import { getIdenticator } from "../api/directory";
import { AuthContext } from "../context/AuthContext";
import { v4 as uuidv4 } from 'uuid';


import * as Yup from 'yup';
import Swal from "sweetalert2";

export const useShareFiado = () => {
    const { setLoading, setAlert, checkToken } = useContext(AuthContext);
    const [object, setObject] = useState({});
    const [processorObject, setProccessorObject] = useState({});
    const [identityInfo, setIdentityInfo] = useState([]);
    const [isRegistered, setIsRegistered] = useState(false);
    const [numero, setNumero] = useState('');
    const [phoneNumber, setPhoneNumber] = useState('');
    const [idempotencyKey, setIdempotencyKey] = useState(null);
    //Se le pasa un array de miembros de grupo.    
    const setFiadoShareObject = async (members) => {

        let objectLocal = object
        members.forEach(element => {

            let id = element.directoryId
            objectLocal[`${id}`] = {
                preferredName: element.preferredName,
                value: 0.00,
                phone: "",
                name: "",
                typeOfDirectoryId: "USER",
                concept: "",
                saveAsFavorite: false,
            }
        });


        setObject(objectLocal);
    }



    //Cambiar el monto de un miembro
    const setAmountToMember = (id, amount) => {
        //console.log('id:' + id)
        let objectLocal = object;
        objectLocal[`${id}`].value = amount
        //console.log(id)
        setObject(objectLocal);
    }

    //Cambiar el concepto de un miembro
    const setConceptToMember = (id, concept) => {
        let objectLocal = object;
        objectLocal[`${id}`].concept = concept;
        setObject(objectLocal);
    }

    //Agrega monto y concepto en comun para todos.
    const setShareDataToAllMembers = (amount = 0, concept = "COMPARTE FIADO") => {
        let objectLocal = object;
        let keys = Object.keys(objectLocal); // valores = ["Scott", "Negro", true, 5];
        for (let i = 0; i < keys.length; i++) {
            objectLocal[keys[i]].value = amount;
            objectLocal[keys[i]].concept = concept;
        }

        setObject(objectLocal);
    }

    const convertToProcessorData = () => {

        let products = [{ id: "FIADO_FUNDS_AVAILABLE_MXN" }]
        let objectLocal = object;

        let keys = Object.keys(objectLocal);
        for (let i = 0; i < keys.length; i++) {

            let product = {
                id: "FIADO_SHARE_MXN",
                "amount": parseInt(objectLocal[keys[i]].value),
                "beneficiaryDirectoryId": keys[i],
                "typeOfDirectoryId": objectLocal[keys[i]].typeOfDirectoryId,
                "concept": objectLocal[keys[i]].concept,
                "saveAsFavorite": objectLocal[keys[i]].saveAsFavorite,
            }

            products.push(product);
        }

        return products;

    }

    const removeMemberFromTransaction = (id) => {
        delete object[`${id}`];
    }

    //Crea objeto para el procesador.
    const createProcessorObject = (originCurrencyId, destinationCurrencyId) => {
        let products = convertToProcessorData();
        let processorObject = {
            originCurrencyId: originCurrencyId,
            destinationCurrencyId: destinationCurrencyId,
            products: products
        }
        setProccessorObject(processorObject);
        return processorObject;        
    }


    /* Indivitual Share Fiado */

    const getIdentify = async (phoneNumber) => {
        checkToken()
        try {
            setLoading(true)
            const { data } = await getIdenticator(phoneNumber);
            setIdentityInfo(data.data);
            setIsRegistered(true);
            setLoading(false)
            return true
        } catch (error) {
            setLoading(false)
            console.log(error)
            return false;
        }
    }

    const closeContact = () => {
        setIsRegistered(false);
        setIdentityInfo([]);
        setPhoneNumber('+52');
        setNumero('');
    }

    const deleteContact = {
        name: 'close',
        direction: 'right',
        color: 'black',
        action: closeContact,
    }

    const getFirstDigits = (string) => {
        checkToken()
        try {
            const remainingDigits = string.substring(0, string.length - 10);
            return remainingDigits;
        } catch (error) {

        }
    }

    const getLastDigits = (string) => {
        const last10Digits = string.substring(string.length - 10);
        return last10Digits;
    }

    const getIdentity = (phoneNumber) => {
        getIdentify(phoneNumber);
        setPhoneNumber(phoneNumber);
        setNumero(getLastDigits(phoneNumber));
    }


    const identify = async () => {
        const response = await getIdentify(phoneNumber);
        if (response === false) {
            const next = () => {
                setIsRegistered(false);
                setIdentityInfo([]);
            }

            Swal.fire({
                showCloseButton: true,
                title: 'Atención',
                text: 'Esta persona no se encuentra registrada en Fiado, pero al enviarle dinero se le generará un link para que se registre y así su dinero llegará a la cuenta',
                icon: 'warning',
                showCancelButton: false,
                confirmButtonColor: '#fd6e0d',
                iconColor: "#fd6e0d",
                confirmButtonText: 'Entendido'
              }).then((result) => {
                if (result.isConfirmed) {
                  next();
                } else{
                  next();
                }
              })
        }
        setIdempotencyKey(uuidv4());
    }


    const getIdentifyByNumber = () => {
        console.log(getFirstDigits(phoneNumber))
        if (getFirstDigits(phoneNumber) === '+1' && phoneNumber.length === 12) {
            console.log('usa')
            identify();
        } else if ((getFirstDigits(phoneNumber) === '+52' || '+57') && phoneNumber.length === 13) {
            console.log('mexico')
            identify();
        } else {

        }
    }


    const amountValidation = Yup.object({
        amount: Yup.number()
            .moreThan(0, 'El monto debe ser mayor a 0'),
    })

    return {
        processorObject,
        setFiadoShareObject,
        setAmountToMember,
        setConceptToMember,
        setShareDataToAllMembers,
        convertToProcessorData,
        createProcessorObject,
        removeMemberFromTransaction,
        object,
        identityInfo,
        isRegistered,
        setIdentityInfo,
        setIsRegistered,
        getIdentify,
        numero,
        setNumero,
        phoneNumber,
        setPhoneNumber,
        deleteContact,
        closeContact,
        getFirstDigits,
        getLastDigits,
        getIdentity,
        getIdentifyByNumber,
        idempotencyKey,
        setIdempotencyKey,
        amountValidation
    }
}